/**
 * Labstep
 *
 * @module components/Folder/Table
 * @desc Table showing folders for ExperimentWorkflow or ProtocolCollection type
 */

import { EntityTableParamsContainer as EntityTable } from 'labstep-web/components/Entity/Table';
import { FolderActionMenu } from 'labstep-web/components/Folder/Action/Menu';
import { ICONS } from 'labstep-web/constants/icons';
import { Flex } from 'labstep-web/core/Flex';
import { Icon } from 'labstep-web/core/Icon';
import { Link } from 'labstep-web/core/Link';
import { Folder, FolderType } from 'labstep-web/models/folder.model';
import type React from 'react';
import type { FolderTableProps } from './types';

export const FolderTable: React.FC<FolderTableProps> = ({
  folders,
  actions,
  ...rest
}) => {
  return (
    <EntityTable
      entities={folders}
      editableName
      withCheckbox={true}
      actionMenu={({ entity }) => (
        <FolderActionMenu
          folder={entity}
          folderType={entity.type}
          actions={actions}
        />
      )}
      primaryColumn={{
        header: 'Collection',
        content: (folder: Folder) => (
          <Flex style={{ gap: '4px', fontWeight: 500 }}>
            <Icon name={ICONS[Folder.entityName].primary} />
            {folder.folder_path}
          </Flex>
        ),
        cellProps: { style: { flex: 3 } },
      }}
      extraColumns={[
        /* {
          header: 'Path',
          content: (folder: Folder) => folder.folderPathWithoutName,
          cellProps: { style: { flex: 2 } },
        }, */
        {
          header: '',
          content: (folder: Folder) => {
            const isProtocolFolder =
              folder.type === FolderType.protocol_collection;
            const count = isProtocolFolder
              ? folder.protocol_collection_count || 0
              : folder.experiment_workflow_count || 0;

            const route = isProtocolFolder
              ? 'group_protocol_collections'
              : 'group_experiment_workflows';

            return (
              <Link
                to={route}
                params={{ id: folder.owner.id }}
                query={{ folder_id: folder.guid }}
                underline
              >
                {count || '0'}{' '}
                {isProtocolFolder ? 'protocols' : 'experiments'}
              </Link>
            );
          },
          cellProps: { style: { flex: 1 } },
        },
      ]}
      {...rest}
    />
  );
};
